import { NewServiceStatus } from '../hooks/useTransformServiceItems/useTransformServiceItems'
import { ServiceInfoStatusEnum } from '../sdk'

export const colorMap: Record<NewServiceStatus, string> = {
  [ServiceInfoStatusEnum.Recommended]: 'info.main',
  [ServiceInfoStatusEnum.Authorized]: 'success.light',
  [ServiceInfoStatusEnum.Deferred]: 'warning.light'
}
export const labelMap: Record<NewServiceStatus, string> = {
  [ServiceInfoStatusEnum.Recommended]: 'Recommended',
  [ServiceInfoStatusEnum.Authorized]: 'Authorized',
  [ServiceInfoStatusEnum.Deferred]: 'Deferred'
}
